"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesIntro() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="services-intro" className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden !bg-[url(https://sloane.uk/wp-content/uploads/2026/02/laptop.jpg)]">
      {}
      <div className="absolute inset-0 bg-cover bg-center !bg-[url(https://sloane.uk/wp-content/uploads/2026/02/laptop.jpg)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white/60" aria-hidden="true" />

      {}
      <div ref={ref} className="relative z-10 max-w-4xl mx-auto px-6 py-24 md:py-32 text-center">
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <h1 className="text-[48px] md:text-[56px] leading-[1.2] font-bold tracking-[-0.2px] text-foreground mb-6">
            Comprehensive Accounting Services
          </h1>

          {}
          <p className="text-[18px] leading-[1.6] mb-8 max-w-2xl mx-auto !text-[hsl(0,0%,0%)] md:text-[20px]">
            Discover our full range of accounting and financial services designed to help your business thrive in a modern, digital world.
          </p>

          {}
          <Link to="#" className="inline-block">
            
          </Link>
        </div>
      </div>
    </section>;
}